export default "__VITE_ASSET__31003022__"